export default __webpack_public_path__ + "maps-examples-heatmap-example-960-fc3da281e1b41fe719249899e6d0b539.png";